import {
  StyleParamType,
  createStylesParams,
  wixFontParam,
  wixColorParam,
} from '@wix/tpa-settings';
import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';
import { IChallengeStyles } from './challengeStyles.types';
import { fontValueFix } from '../../stylesParams';

export const challengeStyles = createStylesParams<IChallengeStyles>({
  mobCardBorderWidth: {
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 1 },
      ai: { description: 'Border width of program cards on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  mobDividerWidth: {
    metadata: {
      type: StyleType.height,
      defaultValue: { type: 'static', value: 1 },
      ai: { description: 'Width of program card dividers on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  mobNameFontSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 24 },
      ai: { description: 'Font size of program names on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  mobParticipantsAndDurationSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: {
        description:
          'Font size of participant counts and program durations on mobile.',
      },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobPriceSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program prices on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  mobButtonSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Font size of program card buttons on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  categoriesTabsMobileFont: {
    metadata: {
      type: StyleType.font,
      defaultValue: { type: 'static', preset: 'Body-M', size: 16 },
      ai: { description: 'Font used by the category selector on mobile.' },
    },
    type: StyleParamType.Font,
    getDefaultValue: ({ textPresets }) => {
      return fontValueFix(
        wixFontParam('Body-M', {
          size: 16,
        }),
        textPresets,
      );
    },
  },
  categoriesTabsMobileFontColor: {
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'color-5' },
      ai: { description: 'Text color of the category selector on mobile.' },
    },
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  categoriesTabsMobileBackgroundColor: {
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: { type: 'static', preset: 'color-1' },
      ai: {
        description: 'Background color of the category selector on mobile.',
      },
    },
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  categoriesTabsMobileBorderColor: {
    metadata: {
      type: StyleType.borderColor,
      defaultValue: { type: 'static', preset: 'color-5' },
      ai: { description: 'Border color of the category selector on mobile.' },
    },
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  categoriesTabsMobileBorderWidth: {
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 1 },
      ai: { description: 'Border width of the category selector on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  categoriesTabsMobileTextSize: {
    metadata: {
      type: StyleType.fontSize,
      defaultValue: { type: 'static', value: 16 },
      ai: { description: 'Text size of the category selector on mobile.' },
    },
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
});
